export const save = (value) => {
  localStorage.setItem('evs.pushNotificationsReminder', value);
};

export const get = () => localStorage.getItem('evs.pushNotificationsReminder') === 'true';
